import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1920}
    height={props.width? `calc( ${props.width}/ 1920 * 753 )`: 753}
    viewBox="0 0 1920 753"
    fill="none"
    {...props}
  >
    <path
      fill="url(#attyy)"
      fillRule="evenodd"
      d="M2049-235.999 1849.29 131H847.195l-27.669 51H-59.526L-174-29h402.643L116-236l1933 .001Z"
      clipRule="evenodd"
    />
    {/* <path
      fill="#000"
      d="M90.68 101.28c-1.54 0-3.04-.66-4.06-1.5l.9-1.22c.94.76 1.9 1.3 3.2 1.3 1.44 0 2.16-.76 2.16-1.72 0-1.1-1.3-1.6-2.5-2.04-1.5-.58-3.16-1.3-3.16-3.16 0-1.72 1.38-3.06 3.74-3.06 1.34 0 2.54.54 3.38 1.22l-.88 1.16c-.74-.54-1.52-.96-2.48-.96-1.38 0-2 .72-2 1.56 0 1.04 1.1 1.44 2.34 1.88 1.58.6 3.3 1.24 3.3 3.3 0 1.78-1.38 3.24-3.94 3.24Zm10.775 0c-2.88 0-5.08-2.1-5.08-5.68 0-3.64 2.44-5.72 5.22-5.72 1.42 0 2.42.58 3.18 1.28l-.92 1.2c-.64-.58-1.32-.96-2.16-.96-2 0-3.44 1.68-3.44 4.2 0 2.48 1.38 4.16 3.38 4.16.98 0 1.88-.48 2.56-1.08l.78 1.22c-.96.86-2.22 1.38-3.52 1.38Zm9.628 0c-2.68 0-5.04-2.1-5.04-5.68 0-3.64 2.36-5.72 5.04-5.72 2.66 0 5.02 2.08 5.02 5.72 0 3.58-2.36 5.68-5.02 5.68Zm0-1.52c1.88 0 3.14-1.68 3.14-4.16 0-2.52-1.26-4.2-3.14-4.2-1.9 0-3.16 1.68-3.16 4.2 0 2.48 1.26 4.16 3.16 4.16Zm7.909 1.24V90.14h1.48l.18 1.98h.06c.74-1.38 1.86-2.24 3.08-2.24.48 0 .8.06 1.16.22l-.34 1.6c-.38-.12-.62-.18-1.06-.18-.9 0-2.02.66-2.74 2.52V101h-1.82Zm11.861.28c-2.9 0-5.2-2.12-5.2-5.68 0-3.54 2.38-5.72 4.88-5.72 2.76 0 4.32 1.98 4.32 5.1 0 .38-.02.76-.08 1.04h-7.32c.14 2.3 1.54 3.8 3.62 3.8 1.04 0 1.9-.34 2.7-.88l.66 1.22c-.96.62-2.1 1.12-3.58 1.12Zm-3.42-6.58h5.82c0-2.18-.98-3.36-2.7-3.36-1.52 0-2.88 1.22-3.12 3.36Z"
    /> */}
    <path fill="#00C9D6" d="m63.29 81.29 14.29 14.29-14.29 14.29L49 95.58z" />
    <g filter="url(#bttyy)">
      <path
        fill="#fff"
        d="m309 181.5-30.673 52.98H65.673L35 181.5l30.673-52.98h212.654L309 181.5Z"
      />
    </g>
    <path
      fill="#E7E7E7"
      d="m269.313 225.918 23.632-43.883H51.055l23.632 43.883h194.626Z"
    />
    <path
      fill="#EAEAEA"
      d="m74.687 138.152-23.632 43.883h241.89l-23.632-43.883H74.687Z"
    />
    <path
      fill="url(#cttyy)"
      stroke="#25FFD8"
      d="m262.019 145.074 21.783 36.961-21.783 36.961H79.84l-21.783-36.961 21.783-36.961h182.179Z"
    />
    {/* <path
      fill="#000"
      d="M118.919 189v-14.9h3.58v5.9h.06l4.22-5.9h3.92l-4.5 5.98 5.34 8.92h-3.9l-3.52-6.1-1.62 2.2v3.9h-3.58Zm18.494.28c-3.28 0-5.8-2.2-5.8-5.98 0-3.68 2.66-5.96 5.4-5.96 3.28 0 4.88 2.38 4.88 5.48 0 .64-.08 1.26-.16 1.54h-6.68c.32 1.56 1.4 2.2 2.84 2.2.82 0 1.58-.24 2.4-.72l1.18 2.14c-1.18.84-2.74 1.3-4.06 1.3Zm-2.42-7.26h3.88c0-1.12-.5-1.96-1.8-1.96-.981 0-1.84.62-2.08 1.96Zm10.262 11.36c-.74 0-1.2-.08-1.68-.22l.64-2.7c.2.04.5.14.76.14 1.08 0 1.64-.56 1.9-1.36l.16-.58-4.36-11.04h3.58l1.52 4.72c.34 1.04.58 2.1.88 3.22h.1c.22-1.08.48-2.14.74-3.22l1.32-4.72h3.4l-3.92 11.4c-1.1 2.92-2.34 4.36-5.04 4.36Zm15.5-4.38v-14.9h9.5v2.98h-5.92v3.26h5.08v2.98h-5.08V189h-3.58Zm11.79 0v-11.38h3.56V189h-3.56Zm1.78-12.96c-1.2 0-1.98-.72-1.98-1.84 0-1.1.78-1.82 1.98-1.82 1.18 0 1.98.72 1.98 1.82 0 1.12-.8 1.84-1.98 1.84Zm4.646 12.96v-11.38h2.9l.26 1.42h.06c.94-.92 2.1-1.7 3.64-1.7 2.48 0 3.54 1.78 3.54 4.62V189h-3.56v-6.6c0-1.58-.42-2.02-1.32-2.02-.8 0-1.28.36-1.96 1.02v7.6h-3.56Zm16.044.28c-2.1 0-3.38-1.56-3.38-3.46 0-2.4 1.88-3.7 6.32-4.18-.08-.92-.56-1.46-1.72-1.46-.9 0-1.84.36-2.98 1l-1.24-2.34c1.5-.9 3.12-1.5 4.9-1.5 2.94 0 4.6 1.64 4.6 5.2V189h-2.9l-.24-1.14h-.1c-.94.84-2 1.42-3.26 1.42Zm1.22-2.76c.72 0 1.2-.34 1.72-.9v-1.82c-2.22.28-2.94.94-2.94 1.74 0 .66.48.98 1.22.98Zm8.029 2.48v-11.38h2.9l.26 1.42h.06c.94-.92 2.1-1.7 3.64-1.7 2.48 0 3.54 1.78 3.54 4.62V189h-3.56v-6.6c0-1.58-.42-2.02-1.32-2.02-.8 0-1.28.36-1.96 1.02v7.6h-3.56Zm18.184.28c-3.2 0-5.66-2.2-5.66-5.98 0-3.76 2.8-5.96 5.98-5.96 1.38 0 2.46.48 3.32 1.22l-1.66 2.26c-.52-.42-.96-.6-1.44-.6-1.58 0-2.56 1.2-2.56 3.08 0 1.9 1.04 3.1 2.42 3.1.72 0 1.4-.34 1.98-.8l1.38 2.34c-1.12.98-2.56 1.34-3.76 1.34Zm5.722-.28v-11.38h3.56V189h-3.56Zm1.78-12.96c-1.2 0-1.98-.72-1.98-1.84 0-1.1.78-1.82 1.98-1.82 1.18 0 1.98.72 1.98 1.82 0 1.12-.8 1.84-1.98 1.84Zm7.526 13.24c-2.1 0-3.38-1.56-3.38-3.46 0-2.4 1.88-3.7 6.32-4.18-.08-.92-.56-1.46-1.72-1.46-.9 0-1.84.36-2.98 1l-1.24-2.34c1.5-.9 3.12-1.5 4.9-1.5 2.94 0 4.6 1.64 4.6 5.2V189h-2.9l-.24-1.14h-.1c-.94.84-2 1.42-3.26 1.42Zm1.22-2.76c.72 0 1.2-.34 1.72-.9v-1.82c-2.22.28-2.94.94-2.94 1.74 0 .66.48.98 1.22.98Zm11.269 2.76c-2.44 0-3.24-1.6-3.24-3.98v-12.28h3.56v12.4c0 .76.34.98.62.98.12 0 .2 0 .4-.04l.42 2.62c-.38.16-.96.3-1.76.3Zm6.801 0c-1.48 0-3.22-.64-4.38-1.6l1.58-2.22c1.04.78 1.98 1.2 2.88 1.2.94 0 1.34-.34 1.34-.9 0-.68-1.1-1-2.26-1.46-1.36-.54-2.9-1.46-2.9-3.36 0-2.14 1.74-3.6 4.4-3.6 1.78 0 3.1.72 4.06 1.46l-1.58 2.12c-.82-.58-1.62-.96-2.36-.96-.82 0-1.2.28-1.2.82 0 .68.98.94 2.16 1.36 1.42.54 3 1.36 3 3.42 0 2.1-1.64 3.72-4.74 3.72Z"
    /> */}
    <path
      fill="#25FFD8"
      fillOpacity={0.5}
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M103.5 190.988v-19.117l-16.59-9.559-16.59 9.559v19.117l16.59 9.559 16.59-9.559Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M86.91 174.011v-11.699M70.32 190.873l8.735-5.081M103.5 190.988l-9.743-5.697"
    />
    {/* <g filter="url(#dttyy)">
      <path
        fill="url(#ettyy)"
        fillOpacity={0.5}
        d="M37.88 261.127 68 231.007l266.301 6.286V597L320 611.301H37.88V261.127Z"
      />
    </g> */}
    {/* <path stroke="#fff" strokeWidth={2} d="m68 230.839-30.289 30.289v347.873" /> */}
 
    <path
      fill="#DBE4E5"
      stroke="#00C9D6"
      strokeWidth={2}
      d="m1039.84 31.586 26.253 26.253-26.253 26.252-26.253-26.252z"
    />
    <path
      fill="#00C9D6"
      d="M1036.09 43.161h7.59l-3.12 10.758h7.44l-10.76 19.242V58.163H1031l5.09-15.002Z"
    />
    <path
      fill="#DBE4E5"
      stroke="#00C9D6"
      strokeWidth={2}
      d="m673.839 31.586 26.253 26.253-26.253 26.252-26.253-26.252z"
    />
    <path fill="#00C9D6" d="M665 48v20l14-10-14-10Zm18 20V48h-4v20h4Z" />
    <path
      fill="#DBE4E5"
      stroke="#00C9D6"
      strokeWidth={2}
      d="m338.839 31.586 26.253 26.253-26.253 26.252-26.253-26.252z"
    />
    <path fill="#00C9D6" d="M343 53.977V47h-14v16h6.105v-9.023H343Z" />
    <path fill="#00C9D6" d="M342.895 53v9.023H335V69h14V53h-6.105Z" />
    <path
      fill="#DBE4E5"
      stroke="#00C9D6"
      strokeWidth={2}
      d="m1463.84 29.586 26.253 26.253-26.253 26.252-26.253-26.252z"
    />
    <path
      fill="#00C9D6"
      d="M1473 49.2c0-2.276-4.12-4.2-9-4.2s-9 1.924-9 4.2v2.1c0 2.276 4.12 4.2 9 4.2s9-1.924 9-4.2v-2.1Zm-9 13.65c-4.88 0-9-1.924-9-4.2v3.15c0 2.276 4.12 4.2 9 4.2s9-1.924 9-4.2v-3.15c0 2.276-4.12 4.2-9 4.2Z"
    />
    <path
      fill="#00C9D6"
      d="M1473 54c0 1.858-4.12 3.429-9 3.429s-9-1.57-9-3.429v2.571c0 1.859 4.12 3.429 9 3.429s9-1.57 9-3.429V54Z"
    />
    <path
      fill="#fff"
      d="m481.479 180.812-34.406 59.593h-68.812l-34.406-59.593 34.406-59.593h68.812l34.406 59.593Z"
    />
    {/* <path
      fill="#000"
      d="M316.241 251v-14.9h3.86l2.36 6.44c.3.86.54 1.8.82 2.7h.1c.3-.9.54-1.84.82-2.7l2.28-6.44h3.88V251h-3.26v-5.1c0-1.48.28-3.7.48-5.16h-.1l-1.24 3.56-2 5.44h-1.96l-2.02-5.44-1.2-3.56h-.08c.18 1.46.46 3.68.46 5.16v5.1h-3.2Zm20.14.28c-2.1 0-3.38-1.56-3.38-3.46 0-2.4 1.88-3.7 6.32-4.18-.08-.92-.56-1.46-1.72-1.46-.9 0-1.84.36-2.98 1l-1.24-2.34c1.5-.9 3.12-1.5 4.9-1.5 2.94 0 4.6 1.64 4.6 5.2V251h-2.9l-.24-1.14h-.1c-.94.84-2 1.42-3.26 1.42Zm1.22-2.76c.72 0 1.2-.34 1.72-.9v-1.82c-2.22.28-2.94.94-2.94 1.74 0 .66.48.98 1.22.98Zm8.028 2.48v-11.38h2.9l.26 1.98h.06c.84-1.52 2.1-2.26 3.24-2.26.68 0 1.06.1 1.38.24l-.58 3.06c-.42-.1-.76-.18-1.26-.18-.84 0-1.86.54-2.44 2.04v6.5h-3.56Zm9.278 0v-15.98h3.5v8.88h.1l3.36-4.28h3.9l-3.96 4.74 4.24 6.64h-3.86l-2.46-4.32-1.32 1.5V251h-3.5Zm17.015.28c-3.28 0-5.8-2.2-5.8-5.98 0-3.68 2.66-5.96 5.4-5.96 3.28 0 4.88 2.38 4.88 5.48 0 .64-.08 1.26-.16 1.54h-6.68c.32 1.56 1.4 2.2 2.84 2.2.82 0 1.58-.24 2.4-.72l1.18 2.14c-1.18.84-2.74 1.3-4.06 1.3Zm-2.42-7.26h3.88c0-1.12-.5-1.96-1.8-1.96-.98 0-1.84.62-2.08 1.96Zm13.283 7.26c-2.86 0-4.02-1.82-4.02-4.5v-4.38h-1.54v-2.64l1.76-.14.4-3.02h2.94v3.02h2.68v2.78h-2.68v4.34c0 1.26.6 1.76 1.44 1.76.36 0 .76-.12 1.04-.22l.56 2.58c-.6.18-1.42.42-2.58.42Zm9.277-.28v-14.9h5.46c3.18 0 5.82 1.1 5.82 4.7 0 3.5-2.64 4.96-5.82 4.96h-1.88V251h-3.58Zm3.58-8.06h1.6c1.7 0 2.62-.74 2.62-2.14 0-1.4-.92-1.86-2.62-1.86h-1.6v4Zm4.46 8.06-3.22-6.16 2.42-2.34 4.8 8.5h-4Zm5.84 0v-11.38h3.56V251h-3.56Zm1.78-12.96c-1.2 0-1.98-.72-1.98-1.84 0-1.1.78-1.82 1.98-1.82 1.18 0 1.98.72 1.98 1.82 0 1.12-.8 1.84-1.98 1.84Zm8.046 13.24c-1.48 0-3.22-.64-4.38-1.6l1.58-2.22c1.04.78 1.98 1.2 2.88 1.2.94 0 1.34-.34 1.34-.9 0-.68-1.1-1-2.26-1.46-1.36-.54-2.9-1.46-2.9-3.36 0-2.14 1.74-3.6 4.4-3.6 1.78 0 3.1.72 4.06 1.46l-1.58 2.12c-.82-.58-1.62-.96-2.36-.96-.82 0-1.2.28-1.2.82 0 .68.98.94 2.16 1.36 1.42.54 3 1.36 3 3.42 0 2.1-1.64 3.72-4.74 3.72Zm6.795-.28v-15.98h3.5v8.88h.1l3.36-4.28h3.9l-3.96 4.74 4.24 6.64h-3.86l-2.46-4.32-1.32 1.5V251h-3.5Zm23.826.28c-3.78 0-6.98-2.6-6.98-7.64 0-4.96 3.32-7.8 7.1-7.8 1.94 0 3.5.9 4.52 1.94l-1.86 2.28c-.76-.68-1.54-1.16-2.6-1.16-1.92 0-3.5 1.72-3.5 4.62 0 2.96 1.36 4.68 3.46 4.68 1.2 0 2.14-.6 2.84-1.36l1.88 2.24c-1.26 1.46-2.92 2.2-4.86 2.2Zm9.64 0c-2.1 0-3.38-1.56-3.38-3.46 0-2.4 1.88-3.7 6.32-4.18-.08-.92-.56-1.46-1.72-1.46-.9 0-1.84.36-2.98 1l-1.24-2.34c1.5-.9 3.12-1.5 4.9-1.5 2.94 0 4.6 1.64 4.6 5.2V251h-2.9l-.24-1.14h-.1c-.94.84-2 1.42-3.26 1.42Zm1.22-2.76c.72 0 1.2-.34 1.72-.9v-1.82c-2.22.28-2.94.94-2.94 1.74 0 .66.48.98 1.22.98Zm8.029 6.62v-15.52h2.9l.26 1.1h.06c.9-.8 2.02-1.38 3.2-1.38 2.72 0 4.44 2.28 4.44 5.78 0 3.92-2.34 6.16-4.78 6.16-.96 0-1.88-.42-2.64-1.18l.12 1.78v3.26h-3.56Zm5.24-6.78c1.08 0 1.96-.9 1.96-3.18 0-2-.58-2.94-1.84-2.94-.66 0-1.2.3-1.8.96v4.5c.56.5 1.14.66 1.68.66Zm7.924 2.64v-11.38h3.56V251h-3.56Zm1.78-12.96c-1.2 0-1.98-.72-1.98-1.84 0-1.1.78-1.82 1.98-1.82 1.18 0 1.98.72 1.98 1.82 0 1.12-.8 1.84-1.98 1.84Zm9.126 13.24c-2.86 0-4.02-1.82-4.02-4.5v-4.38h-1.54v-2.64l1.76-.14.4-3.02h2.94v3.02h2.68v2.78h-2.68v4.34c0 1.26.6 1.76 1.44 1.76.36 0 .76-.12 1.04-.22l.56 2.58c-.6.18-1.42.42-2.58.42Zm6.681 0c-2.1 0-3.38-1.56-3.38-3.46 0-2.4 1.88-3.7 6.32-4.18-.08-.92-.56-1.46-1.72-1.46-.9 0-1.84.36-2.98 1l-1.24-2.34c1.5-.9 3.12-1.5 4.9-1.5 2.94 0 4.6 1.64 4.6 5.2V251h-2.9l-.24-1.14h-.1c-.94.84-2 1.42-3.26 1.42Zm1.22-2.76c.72 0 1.2-.34 1.72-.9v-1.82c-2.22.28-2.94.94-2.94 1.74 0 .66.48.98 1.22.98Zm11.269 2.76c-2.44 0-3.24-1.6-3.24-3.98v-12.28h3.56v12.4c0 .76.34.98.62.98.12 0 .2 0 .4-.04l.42 2.62c-.38.16-.96.3-1.76.3Z"
    /> */}
    <path
      fill="#E7E7E7"
      d="m441.299 228.38 28.172-47.106H356.785l28.172 47.106h56.342Z"
    />
    <path
      fill="#EAEAEA"
      d="m384.957 132.32-28.171 48.954h112.685L441.3 132.32h-56.343Z"
    />
    <path
      fill="url(#fttyy)"
      stroke="#FF7272"
      d="m435.962 141.84 22.816 39.896-22.816 39.895h-45.624l-22.816-39.895 22.816-39.896h45.624Z"
    />
    <path
      fill="#FF7272"
      fillOpacity={0.2}
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m413.13 150.793-18.171 6.686-9.669 16.925 3.36 19.247 14.811 12.561h19.336l14.813-12.561 3.357-19.247-9.669-16.925-18.168-6.686Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m389.113 193.281 24.015-41.564 24.015 41.564"
    />
    <path
      fill="#fff"
      d="m413.13 187.74 1.846-24.015h-3.695l1.849 24.015ZM413.13 194.673a1.61 1.61 0 0 0 1.602-1.619 1.61 1.61 0 0 0-1.602-1.62c-.885 0-1.603.725-1.603 1.62 0 .894.718 1.619 1.603 1.619ZM820.458 180.812l-34.406 59.593H717.24l-34.406-59.593 34.406-59.593h68.812l34.406 59.593Z"
    />
    {/* <path
      fill="#000"
      d="m671.264 251 4.62-14.9h4.28l4.62 14.9h-3.76l-1.86-7.44c-.4-1.48-.78-3.26-1.18-4.78h-.08c-.36 1.56-.76 3.3-1.14 4.78l-1.86 7.44h-3.64Zm3.14-3.42v-2.76h7.2v2.76h-7.2Zm15.219 3.7c-1.48 0-3.22-.64-4.38-1.6l1.58-2.22c1.04.78 1.98 1.2 2.88 1.2.94 0 1.34-.34 1.34-.9 0-.68-1.1-1-2.26-1.46-1.36-.54-2.9-1.46-2.9-3.36 0-2.14 1.74-3.6 4.4-3.6 1.78 0 3.1.72 4.06 1.46l-1.58 2.12c-.82-.58-1.62-.96-2.36-.96-.82 0-1.2.28-1.2.82 0 .68.98.94 2.16 1.36 1.42.54 3 1.36 3 3.42 0 2.1-1.64 3.72-4.74 3.72Zm10.196 0c-1.48 0-3.22-.64-4.38-1.6l1.58-2.22c1.04.78 1.98 1.2 2.88 1.2.94 0 1.34-.34 1.34-.9 0-.68-1.1-1-2.26-1.46-1.36-.54-2.9-1.46-2.9-3.36 0-2.14 1.74-3.6 4.4-3.6 1.78 0 3.1.72 4.06 1.46l-1.58 2.12c-.82-.58-1.62-.96-2.36-.96-.82 0-1.2.28-1.2.82 0 .68.98.94 2.16 1.36 1.42.54 3 1.36 3 3.42 0 2.1-1.64 3.72-4.74 3.72Zm11.955 0c-3.28 0-5.8-2.2-5.8-5.98 0-3.68 2.66-5.96 5.4-5.96 3.28 0 4.88 2.38 4.88 5.48 0 .64-.08 1.26-.16 1.54h-6.68c.32 1.56 1.4 2.2 2.84 2.2.82 0 1.58-.24 2.4-.72l1.18 2.14c-1.18.84-2.74 1.3-4.06 1.3Zm-2.42-7.26h3.88c0-1.12-.5-1.96-1.8-1.96-.98 0-1.84.62-2.08 1.96Zm13.283 7.26c-2.86 0-4.02-1.82-4.02-4.5v-4.38h-1.54v-2.64l1.76-.14.4-3.02h2.94v3.02h2.68v2.78h-2.68v4.34c0 1.26.6 1.76 1.44 1.76.36 0 .76-.12 1.04-.22l.56 2.58c-.6.18-1.42.42-2.58.42Zm7.396-.28 4.62-14.9h4.28l4.62 14.9h-3.76l-1.86-7.44c-.4-1.48-.78-3.26-1.18-4.78h-.08c-.36 1.56-.76 3.3-1.14 4.78l-1.86 7.44h-3.64Zm3.14-3.42v-2.76h7.2v2.76h-7.2Zm14.903 3.7c-2.44 0-3.24-1.6-3.24-3.98v-12.28h3.56v12.4c0 .76.34.98.62.98.12 0 .2 0 .4-.04l.42 2.62c-.38.16-.96.3-1.76.3Zm6.641 0c-2.44 0-3.24-1.6-3.24-3.98v-12.28h3.56v12.4c0 .76.34.98.62.98.12 0 .2 0 .4-.04l.42 2.62c-.38.16-.96.3-1.76.3Zm8.341 0c-2.9 0-5.58-2.2-5.58-5.98 0-3.76 2.68-5.96 5.58-5.96 2.88 0 5.56 2.2 5.56 5.96 0 3.78-2.68 5.98-5.56 5.98Zm0-2.88c1.32 0 1.92-1.2 1.92-3.1 0-1.88-.6-3.08-1.92-3.08-1.34 0-1.94 1.2-1.94 3.08 0 1.9.6 3.1 1.94 3.1Zm12.814 2.88c-3.2 0-5.66-2.2-5.66-5.98 0-3.76 2.8-5.96 5.98-5.96 1.38 0 2.46.48 3.32 1.22l-1.66 2.26c-.52-.42-.96-.6-1.44-.6-1.58 0-2.56 1.2-2.56 3.08 0 1.9 1.04 3.1 2.42 3.1.72 0 1.4-.34 1.98-.8l1.38 2.34c-1.12.98-2.56 1.34-3.76 1.34Zm8.231 0c-2.1 0-3.38-1.56-3.38-3.46 0-2.4 1.88-3.7 6.32-4.18-.08-.92-.56-1.46-1.72-1.46-.9 0-1.84.36-2.98 1l-1.24-2.34c1.5-.9 3.12-1.5 4.9-1.5 2.94 0 4.6 1.64 4.6 5.2V251h-2.9l-.24-1.14h-.1c-.94.84-2 1.42-3.26 1.42Zm1.22-2.76c.72 0 1.2-.34 1.72-.9v-1.82c-2.22.28-2.94.94-2.94 1.74 0 .66.48.98 1.22.98Zm11.943 2.76c-2.86 0-4.02-1.82-4.02-4.5v-4.38h-1.54v-2.64l1.76-.14.4-3.02h2.94v3.02h2.68v2.78h-2.68v4.34c0 1.26.6 1.76 1.44 1.76.36 0 .76-.12 1.04-.22l.56 2.58c-.6.18-1.42.42-2.58.42Zm4.426-.28v-11.38h3.56V251h-3.56Zm1.78-12.96c-1.2 0-1.98-.72-1.98-1.84 0-1.1.78-1.82 1.98-1.82 1.18 0 1.98.72 1.98 1.82 0 1.12-.8 1.84-1.98 1.84Zm9.586 13.24c-2.9 0-5.58-2.2-5.58-5.98 0-3.76 2.68-5.96 5.58-5.96 2.88 0 5.56 2.2 5.56 5.96 0 3.78-2.68 5.98-5.56 5.98Zm0-2.88c1.32 0 1.92-1.2 1.92-3.1 0-1.88-.6-3.08-1.92-3.08-1.34 0-1.94 1.2-1.94 3.08 0 1.9.6 3.1 1.94 3.1Zm7.794 2.6v-11.38h2.9l.26 1.42h.06c.94-.92 2.1-1.7 3.64-1.7 2.48 0 3.54 1.78 3.54 4.62V251h-3.56v-6.6c0-1.58-.42-2.02-1.32-2.02-.8 0-1.28.36-1.96 1.02v7.6h-3.56Z"
    /> */}
    <path
      fill="#E7E7E7"
      d="m780.279 228.38 28.171-47.106H695.765l28.171 47.106h56.343Z"
    />
    <path
      fill="#EAEAEA"
      d="m723.937 132.32-28.171 48.954h112.685L780.28 132.32h-56.343Z"
    />
    <path
      fill="url(#gttyy)"
      stroke="#F90"
      d="m773.975 140.917 22.816 39.895-22.816 39.895h-45.624l-22.816-39.895 22.816-39.895h45.624Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m751.49 148.022-5.672 18.664 5.672 3.686 5.668-3.686-5.668-18.664ZM773.512 156.056l-16.355 10.631 1.966 6.47 6.712.828 7.677-17.929Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m785.198 176.376-19.361-2.381-2.657 6.218 4.603 4.953 17.415-8.79Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m781.055 199.472-13.269-14.306-6.05 3.066.324 6.774 18.995 4.466Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m763.198 214.525-1.021-19.48-6.584-1.538-4.076 5.395 11.681 15.623Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m739.782 214.516 11.761-15.563-4.051-5.415-6.592 1.503-1.118 19.475Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m721.878 199.359 19.015-4.35.383-6.751-6.015-3.091-13.383 14.192Z"
    />
    <path
      fill="#F90"
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m717.911 176.255 17.35 8.916 4.639-4.92-2.613-6.238-19.376 2.242Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m729.191 156.464 8.145 17.725 6.687-1.005 1.794-6.52-16.626-10.2Z"
    />
    <path
      fill="#fff"
      d="m656.973 180.812-34.406 59.593h-68.812l-34.406-59.593 34.406-59.593h68.812l34.406 59.593Z"
    />
    <path
      fill="#D7DCE0"
      d="m616.794 228.38 28.171-47.106H532.28l28.171 47.106h56.343Z"
    />
    <path
      fill="#E7EBEC"
      d="m560.452 132.32-28.172 48.954h112.686l-28.172-48.954h-56.342Z"
    />
    {/* <path
      fill="#000"
      d="M542.768 251v-11.92h-4.02v-2.98h11.64v2.98h-4.04V251h-3.58Zm12.639.28c-2.9 0-5.58-2.2-5.58-5.98 0-3.76 2.68-5.96 5.58-5.96 2.88 0 5.56 2.2 5.56 5.96 0 3.78-2.68 5.98-5.56 5.98Zm0-2.88c1.32 0 1.92-1.2 1.92-3.1 0-1.88-.6-3.08-1.92-3.08-1.34 0-1.94 1.2-1.94 3.08 0 1.9.6 3.1 1.94 3.1Zm11.493 2.88c-2.86 0-4.02-1.82-4.02-4.5v-4.38h-1.54v-2.64l1.76-.14.4-3.02h2.94v3.02h2.68v2.78h-2.68v4.34c0 1.26.6 1.76 1.44 1.76.36 0 .76-.12 1.04-.22l.56 2.58c-.6.18-1.42.42-2.58.42Zm6.682 0c-2.1 0-3.38-1.56-3.38-3.46 0-2.4 1.88-3.7 6.32-4.18-.08-.92-.56-1.46-1.72-1.46-.9 0-1.84.36-2.98 1l-1.24-2.34c1.5-.9 3.12-1.5 4.9-1.5 2.94 0 4.6 1.64 4.6 5.2V251h-2.9l-.24-1.14h-.1c-.94.84-2 1.42-3.26 1.42Zm1.22-2.76c.72 0 1.2-.34 1.72-.9v-1.82c-2.22.28-2.94.94-2.94 1.74 0 .66.48.98 1.22.98Zm11.269 2.76c-2.44 0-3.24-1.6-3.24-3.98v-12.28h3.56v12.4c0 .76.34.98.62.98.12 0 .2 0 .4-.04l.42 2.62c-.38.16-.96.3-1.76.3Zm8.251-.28v-14.9h5.24c3.26 0 5.96 1.18 5.96 4.86 0 3.54-2.72 5.1-5.88 5.1h-1.74V251h-3.58Zm3.58-7.76h1.56c1.74 0 2.58-.82 2.58-2.28 0-1.5-.96-2.02-2.68-2.02h-1.46v4.3Zm16.45 8.04c-3.78 0-6.98-2.6-6.98-7.64 0-4.96 3.32-7.8 7.1-7.8 1.94 0 3.5.9 4.52 1.94l-1.86 2.28c-.76-.68-1.54-1.16-2.6-1.16-1.92 0-3.5 1.72-3.5 4.62 0 2.96 1.36 4.68 3.46 4.68 1.2 0 2.14-.6 2.84-1.36l1.88 2.24c-1.26 1.46-2.92 2.2-4.86 2.2Zm7.04-.28v-14.9h5.46c3.18 0 5.82 1.1 5.82 4.7 0 3.5-2.64 4.96-5.82 4.96h-1.88V251h-3.58Zm3.58-8.06h1.6c1.7 0 2.62-.74 2.62-2.14 0-1.4-.92-1.86-2.62-1.86h-1.6v4Zm4.46 8.06-3.22-6.16 2.42-2.34 4.8 8.5h-4Z"
    /> */}
    <path
      fill="url(#httyy)"
      stroke="#00A4AF"
      d="m610.973 141.84 22.816 39.896-22.816 39.895h-45.624l-22.816-39.895 22.816-39.896h45.624Z"
    />
    <g filter="url(#ittyy)">
      <path
        fill="#00A4AF"
        fillOpacity={0.2}
        d="m609.462 159.106-14.478 14.286a13.537 13.537 0 0 1 2.029 7.142c0 6.651-4.797 12.191-11.162 13.449l3.8 19.618c15.725-3.013 27.604-16.667 27.604-33.063 0-8.141-2.925-15.602-7.793-21.428v-.004Z"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="M609.377 160.595c4.314 5.522 6.878 12.434 6.878 19.943 0 15.557-11.03 28.585-25.815 31.879l-3.424-17.679c6.327-1.694 10.997-7.4 10.997-14.204 0-2.522-.643-4.899-1.775-6.974l13.139-12.965Z"
      />
    </g>
    <g filter="url(#jttyy)">
      <path
        fill="#00A4AF"
        fillOpacity={0.2}
        d="M592.226 150.895c-2.901-.147-6.472-.229-9.147.444l2.122 16.386c1.453-.365 4.651-.5 6.171.011a11.557 11.557 0 0 1 9.068 5.178l14.019-9.162c-4.775-7.548-12.635-12.368-22.233-12.857Z"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="m584.189 152.124 1.869 14.43a19.016 19.016 0 0 1 2.19-.152c1.138-.015 2.389.066 3.306.343 3.737.23 6.996 2.07 9.138 4.809l12.381-8.091c-4.643-6.802-11.982-11.115-20.898-11.569l-7.986.23Zm0 0c2.396-.431 5.392-.361 7.986-.23l-7.986.23Z"
      />
    </g>
    <g filter="url(#kttyy)">
      <path
        fill="#00A4AF"
        fillOpacity={0.2}
        d="M594.454 193.683a13.477 13.477 0 0 1-10.382 2.962c-7.395-.992-12.587-7.793-11.595-15.188.992-7.395 7.793-12.587 15.188-11.595.484.065.958.155 1.425.271l1.71-12.75c-.47-.09-.949-.169-1.43-.234-14.417-1.933-27.672 8.186-29.606 22.603-1.933 14.417 8.186 27.672 22.603 29.606 7.727 1.036 15.118-1.393 20.61-6.085l-8.527-9.591.004.001Z"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="M583.939 197.636a14.462 14.462 0 0 0 10.384-2.592l7.215 8.116c-5.193 4.088-11.969 6.155-19.038 5.206-13.869-1.86-23.605-14.611-21.745-28.481 1.861-13.87 14.612-23.605 28.482-21.745.148.02.296.042.444.064l-1.44 10.733a16.295 16.295 0 0 0-.443-.066c-7.943-1.065-15.247 4.511-16.312 12.453-1.065 7.943 4.511 15.247 12.453 16.312Z"
      />
    </g>
    <defs>
      <filter
        id="bttyy"
        width={314}
        height={145.961}
        x={15}
        y={110.52}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.88 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_305_13" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_305_13"
          result="shape"
        />
      </filter>
      <filter
        id="dttyy"
        width={336.421}
        height={420.293}
        x={17.88}
        y={211.007}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={10} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_305_13"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_305_13"
          result="shape"
        />
      </filter>
      <filter
        id="ittyy"
        width={41.404}
        height={64.495}
        x={580.851}
        y={154.106}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_305_13"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_305_13"
          result="shape"
        />
      </filter>
      <filter
        id="jttyy"
        width={41.38}
        height={32.12}
        x={578.079}
        y={145.793}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_305_13"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_305_13"
          result="shape"
        />
      </filter>
      <filter
        id="kttyy"
        width={53.45}
        height={62.682}
        x={554.527}
        y={151.913}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_305_13"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_305_13"
          result="shape"
        />
      </filter>
      <radialGradient
        id="cttyy"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-100.729 0 0 -62.154 170.93 182.035)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#25FFD8" stopOpacity={0.5} />
        <stop offset={0.335} stopColor="#25FFD8" stopOpacity={0.2} />
        <stop offset={1} stopColor="#25FFD8" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="fttyy"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-46.2043 0 0 -46.6443 413.15 181.736)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7272" stopOpacity={0.5} />
        <stop offset={1} stopColor="#FF7272" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="gttyy"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-46.2043 0 0 -46.6443 751.163 180.812)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" stopOpacity={0.5} />
        <stop offset={1} stopColor="#FFB800" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="httyy"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-46.2043 0 0 -46.6443 588.161 181.736)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2EE6FF" stopOpacity={0.5} />
        <stop offset={1} stopColor="#2EE6FF" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="attyy"
        x1={938}
        x2={938}
        y1={-10.5}
        y2={182}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.497} stopColor="#E7E7E7" />
        <stop offset={1} stopColor="#E7FFFE" />
      </linearGradient>
      <linearGradient
        id="ettyy"
        x1={163.487}
        x2={163.487}
        y1={527.596}
        y2={238.723}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
